var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ott-main',[_c('ott-h1',[_vm._v(_vm._s(_vm.$t("propertyTaxAssessment")))]),_c('TaxAssessmentWidget',{attrs:{"apiServer":_vm.inferApiServer}}),_c('OttawaTopButton',{attrs:{"currentLanguage":_vm.getCurrentLang}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }